export const getYears = (back) => {
  const year = new Date().getFullYear();
  return Array.from({ length: back }, (v, i) => ({ id: year - back + i + 1, name: `${year - back + i + 1}` }));
};
